import styled, {ThemeProps} from 'styled-components';
import {Assign} from 'utility-types';

import {Theme} from '../../../../../theme/types';

export const SearchLabel = styled.label`
  opacity: 0;
  visibility: 'hidden';
`;

export const SearchInput = styled.input(
  (props: ThemeProps<Theme>) => `
  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props.theme.spacing.small.s5};

  width: 93%;
  height: 3rem;
  border-radius: 0;
  border: none;
  &:focus {
    box-shadow: none;
    outline: none;
  }
  &::-webkit-input-placeholder{
    color: ${props.theme.colors.grey.grey75};
  }
`,
);

export const AutocompleteWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  width: 100%;
  align-items: flex-end;
  margin: 0 0 ${props.theme.spacing.small.s5} 0
`,
);

export const InputWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  display: flex;
  flex-wrap: column;
  width: 100%;
  background-color: ${props.theme.colors.white.base};
  padding: ${props.theme.spacing.small.s5};
  border-radius: ${props.theme.misc.borderRadius.base};
  border: solid 1px rgba(0, 0, 0, 0.25);
  flex-direction: row;
  align-items: center;
  position: relative;
`,
);

export const Menu = styled.ul(
  (props: Assign<ThemeProps<Theme>, {shouldOpenMenu: boolean}>) => `
  z-index: ${props.theme.misc.zIndex.base};
  position: absolute;
  top: 5.4rem;
  list-style-type: none;
  background: ${props.theme.colors.white.base};
  border-radius: 4px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  transform: translateY(4px);
  min-width: 270px;
  max-height: 50vh;
  overflow-y: auto;
  ${SearchListItem} :first-of-type {
    border-top: none;
  }
`,
);

export const SearchListItem = styled.li((props: Assign<ThemeProps<Theme>, {noBorder: boolean}>) => {
  ``;
  const borderBottom = props.noBorder ? 'none' : `1px solid ${props.theme.colors.grey.grey15}`;

  return `
  border-bottom: ${borderBottom};
  background: ${
    // @ts-ignore
    props.isActive ? props.theme.colors.grey.grey15 : props.theme.colors.white.base
  };
  min-height: 48px;
  font-size: ${props.theme.font.base};

  display: flex;
  align-items: center;
  cursor: pointer;
`;
});

export const SearchListItemText = styled.div(
  (props: ThemeProps<Theme>) => `
  flex: 3;
  padding: ${props.theme.spacing.small.s5} 0;
`,
);

export const MidListItemSegregationLabel = styled.h3(
  (props: ThemeProps<Theme>) => `
  min-height: 46px;
  display: flex;
  align-items: center;
  padding-left: ${props.theme.spacing.large.l20};
  font-weight: bold;
  font-size: ${props.theme.font.large.font14};
  background: ${props.theme.colors.blue.bgBlue};
`,
);

export const ErrorMessage = styled.div(
  (props: ThemeProps<Theme>) => `
  padding: ${props.theme.spacing.small.s5};
  color: ${props.theme.colors.red.base};
`,
);

export const IconWrapperDiv = styled.div(
  (props: ThemeProps<Theme>) => `
  height: ${props.theme.spacing.large.l15};
  width: ${props.theme.spacing.large.l15};
  margin: 0 ${props.theme.spacing.base} 0 ${props.theme.spacing.large.l15};
`,
);

export const RatingWrapper = styled.div(
  (props: ThemeProps<Theme>) => `
  flex: 1
`,
);

export const StaticLocationItemWrapper = styled.div`
  display: flex;
  width: 24rem;
`;

export const StaticLocationName = styled.span(
  props => `
  // padding: 0 0 0 ${props.theme.spacing.small.s5};
`,
);

export const StaticLocationCount = styled.span(
  props => `
  margin-left: auto;
  color:${props.theme.colors.grey.grey50};
  position:absolute;
  right:2rem;
`,
);

export const StaticLocationsCheckboxesWrapper = styled.div(
  props => `
  // padding: '0px ${props.theme.spacing.large.l15} 0px ${props.theme.spacing.base}';
`,
);

export const ScrollToTopWhenNoInputHiddenElement = styled.div`
  position: relative;
  visibility: hidden;
  opacity: 0;
`;
